export interface Breakpoints {
    xxl: number
    xl: number
    lg: number
    mlg: number
    md: number
    sm: number
    xs: number
    xxs: number
}

export const breakpoints: Breakpoints = {
    xxl: 1560,
    xl: 1440,
    lg: 1280,
    mlg: 1140,
    md: 1020,
    sm: 768,
    xs: 660,
    xxs: 480,
}

export type BreakpointKeys = keyof Breakpoints

export const availableBreakpoints: BreakpointKeys[] = Object.keys(
    breakpoints,
) as any
